import {Dispatch} from 'redux';

import Types from '../Types';

import AppState from '../../reducers/AppState';

import indexGenerics, {Params as BaseParams} from '../generics/index';

import ActorHairStyle from '../../../domain/entities/ActorHairStyle';
import PaginatedResult from '../../../domain/results/PaginatedResult';

import NetActorHairStylesRepository from '../../../data/repositories/writer/NetActorHairStylesRepository';

const types = {
  failure: Types.IndexActorHairStylesFailure,
  request: Types.IndexActorHairStylesRequest,
  success: Types.IndexActorHairStylesSuccess,
};

export interface Params extends BaseParams {
  actorId: number;
  actorCostumeId: number;
  actorAccessorySetId?: number;
}

export default function action(
  params: Params,
): (
  dispatch: Dispatch<any>,
  getState: () => AppState,
) => Promise<PaginatedResult<ActorHairStyle>> {
  return indexGenerics(new NetActorHairStylesRepository(), types, params);
}
